import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const navLinks = [
  { to: '/ai-resume-builder', label: 'AI Resume Builder' },
  { to: '/ats-resume-builder', label: 'ATS Resume Builder' },
  { to: '/resume-templates', label: 'Resume Templates' },
  { to: '/resume-builder-for-students', label: 'For Students' },
  { to: '/resume-builder-for-no-experience', label: 'No Experience' },
  { to: '/pricing', label: 'Pricing' },
];

export function Header() {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  const isEditor = location.pathname.startsWith('/app');
  if (isEditor) return null;

  return (
    <header className="sticky top-0 z-40 h-[72px] border-b border-white/[0.08] bg-[#0A2540]/85 backdrop-blur-md">
      <div className="mx-auto flex h-full max-w-[1200px] items-center justify-between px-6">
        <Link to="/" className="flex items-center gap-2">
          <span className="text-xl font-bold text-[#00D4AA]">ai-free-resume</span>
        </Link>

        <nav className="hidden items-center gap-6 lg:flex">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`relative text-[15px] font-medium transition-colors ${
                isActive(link.to) ? 'text-[#00D4AA]' : 'text-white/85 hover:text-[#00D4AA]'
              }`}
            >
              {link.label}
              {isActive(link.to) && (
                <span className="absolute -bottom-1 left-0 h-0.5 w-full bg-[#00D4AA]" />
              )}
            </Link>
          ))}
          <Link
            to="/app/create"
            className="btn-primary inline-flex items-center justify-center rounded-[10px] px-6 py-2.5 text-[16px] font-semibold"
          >
            Create My Free Resume
          </Link>
        </nav>

        <button
          className="text-white lg:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="absolute inset-x-0 top-[72px] z-50 border-b border-white/[0.08] bg-[#0A2540] px-6 py-6 lg:hidden">
          <nav className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setOpen(false)}
                className={`text-lg font-medium ${
                  isActive(link.to) ? 'text-[#00D4AA]' : 'text-white/85'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/app/create"
              onClick={() => setOpen(false)}
              className="btn-primary mt-4 inline-flex items-center justify-center rounded-[10px] px-6 py-3 text-base font-semibold"
            >
              Create My Free Resume
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}

export default Header;
